<template>
	<v-layout row v-if="!dataSame && contestId">
		<v-flex xs6>
			<old-version-marker/>
			<choose-actions
				:contest-id="contestId"
				:actions.sync="old"
				:new-version="current"
				:readonly="true"
				:number-of-modules="numberOfModules"
				:module-number="moduleNumber"
			/>
		</v-flex>
		<v-flex xs6>
			<new-version-marker/>
			<choose-actions
				:contest-id="contestId"
				:actions.sync="current"
				:old-version="old"
				:readonly="true"
				:number-of-modules="numberOfModules"
				:module-number="moduleNumber"
			/>
		</v-flex>
	</v-layout>
</template>

<script>
	import OldVersionMarker from "./oldVersionMarker";
	import NewVersionMarker from "./NewVersionMarker";
	import ChooseActions from "../components/ChooseActions";

	export default {
		name: "CompareActions",

		components: {ChooseActions, NewVersionMarker, OldVersionMarker},

		computed: {
			dataSame () {
				if (this.old === undefined || this.current === undefined) {
					return false;
				}

        let idKeyReplacer = (key, value) => {
          if (key === 'id') {
            return undefined;
          }
          return value;
        };

				let oldCopy = JSON.parse(JSON.stringify(this.old, idKeyReplacer));
				let currentCopy = JSON.parse(JSON.stringify(this.current, idKeyReplacer));

				let comparisonResult = JSON.stringify(oldCopy) === JSON.stringify(currentCopy);

				if (comparisonResult === false) {
					this.$emit('dataDiffer', true);
				}
				return comparisonResult;
			}
		},

		props: {
			old: {},
			current: {},
			contestId: {},
			moduleNumber: {
				default: "",
			},
			numberOfModules: {
				default: 0,
			},
		}
	};
</script>

<style scoped>

</style>
